import { CoreConfirmationModal, CoreModalDescription, CoreSpinner } from "../../core";
import i18nPackage from "../../i18n/i18n";
import { Box, Link, Typography } from "@mui/material";
import { Trans } from "react-i18next";
import styles from "./DisclaimerModal.module.css";

type DisclaimerModalProps = {
	verifyingTheme: boolean;
	onClose: () => void;
	onSubmit: () => void;
};

/* Disclaimer modal regarding Canvas Theme */
export default function DisclaimerModal({ verifyingTheme, onClose, onSubmit }: DisclaimerModalProps) {
	return (
		<CoreConfirmationModal
			title={i18nPackage.t("editQuizPage.disclaimerModal.title")}
			padding={"20px"}
			open
			onClose={onClose}
			slotProps={{
				confirmButton: {
					text: i18nPackage.t("editQuizPage.disclaimerModal.continue"),
				},
			}}
			onConfirm={onSubmit}
			checkboxLabel={i18nPackage.t("editQuizPage.disclaimerModal.checkboxText")}
			confirmationType="checkbox"
		>
			<Box className={styles.disclaimerContainer}>
				{verifyingTheme ? (
					<CoreSpinner size={100} />
				) : (
					<>
						<Typography className={styles.disclaimerLink}>
							<Trans
								i18nKey="editQuizPage.disclaimerModal.bodyLink"
								components={{
									a: (
										<Link
											href="https://support.yuja.com/hc/en-us/articles/7332584857623-Integrating-YuJa-Verity-for-Test-Proctoring-into-Canvas#h_01HCJH9QWSFKKFBYSG3TX75XM1"
											target="_blank"
											rel="noreferrer"
											aria-label={i18nPackage.t("editQuizPage.disclaimerModal.disclaimerAriaLabel")}
										/>
									),
								}}
							/>
						</Typography>
						<CoreModalDescription>{i18nPackage.t("editQuizPage.disclaimerModal.bodyText")}</CoreModalDescription>
					</>
				)}
			</Box>
		</CoreConfirmationModal>
	);
}
